import { lazyVue } from "@/utils";
export default [{
    path: '/serviceDetail',
    name: 'serviceDetail',
    title: '服务详情',
    component: lazyVue('serviceDetail/index'),
    meta: {
        // showBar:1,
        isKeepAlive:true,
        title: '服务详情',
        name: '服务详情'
    }   
}]



// WEBPACK FOOTER //
// ./src/router/serviceDetail/index.js